import { AuthService } from 'src/app/core/auth/auth.service';
import { NotificationsService } from 'src/app/shared/notifications/notifications.service';


import { NgModule, LOCALE_ID } from '@angular/core';
import { CommonModule, registerLocaleData } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import localePT from '@angular/common/locales/pt';
import localeExtraPT from '@angular/common/locales/extra/pt';



import { InputMaskModule } from 'primeng/inputmask';
import { MessageModule } from 'primeng/message';
import { MessagesModule } from 'primeng/messages';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { TooltipModule } from 'primeng/tooltip';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { CheckboxModule } from 'primeng/checkbox';
import { CardModule } from 'primeng/card';
import { DialogModule } from 'primeng/dialog';
import { CalendarModule } from 'primeng/calendar';
import { DropdownModule } from 'primeng/dropdown';

import { ScrollPanelModule } from 'primeng/scrollpanel';
import { TimelineModule } from 'primeng/timeline';
import { WoOrderStatusGridComponent } from './pages/wo-order-status-grid/wo-order-status-grid.component';
import { LoaderModule } from 'src/app/shared/components/loader/loader.module';
import { NotificationsModule } from 'src/app/shared/notifications/notifications.module';
import { InputNumberModule } from 'primeng/inputnumber';
import { AuthorizationGuard } from 'src/app/core/guards/authorization.guard';
import { TableModule } from 'primeng/table';
import { WoOrderStatusTimelineComponent } from './pages/wo-order-status-timeline/wo-order-status-timeline.component';
import { WoOrderStatusService } from 'src/app/core/services/wo-order-status/wo-order-status.service';
import { WoOrderStatusStageService } from 'src/app/core/services/wo-order-status/wo-order-status-stage.service';
import { SfDropDownModule } from 'src/app/shared/components/dropdown/dropdown.module';
import { SfBreadCrumbModule } from 'src/app/shared/components/sf-breadcrumb/sf-breadcrumb.module';
import { SfSubHeaderModule } from 'src/app/shared/components/sub-header/sub-header.module';
import { DividerModule } from 'primeng/divider';




registerLocaleData(localePT, 'pt', localeExtraPT);

@NgModule({
    declarations: [WoOrderStatusGridComponent, WoOrderStatusTimelineComponent ],
    exports: [WoOrderStatusGridComponent, WoOrderStatusTimelineComponent],
        imports: [FormsModule,
            FormsModule,
            ReactiveFormsModule,
            CommonModule,
            RouterModule,
            ButtonModule,
            InputTextModule,
            InputMaskModule,
            CheckboxModule,
            TranslateModule,
            MessageModule,
            MessagesModule,
            TableModule,
            TooltipModule,
            ConfirmDialogModule,
            LoaderModule,
            CardModule,
            DialogModule,
            NotificationsModule,
            DropdownModule,
            InputNumberModule,
            CalendarModule,
            InputTextModule,
            ScrollPanelModule,
            TimelineModule,
            SfBreadCrumbModule,
            SfSubHeaderModule,
            SfDropDownModule,
            DividerModule
        ],
    providers: [NotificationsService, AuthService, AuthorizationGuard, WoOrderStatusService, WoOrderStatusStageService, {provide: LOCALE_ID, useValue: 'pt'}]
})
export class WoOrderStatusModule { }


